module.exports = "<div [class]=\"adType\">\r\n<ins [attr.class]=\"adData.class\" [attr.data-key]=\"adData.dataKey\"></ins>\r\n</div>\r\n"